// This component wraps around Image Gallery, Social Icons, Video Blocks, Bandsintown, and Links.(Any block what previously had a block header and settings button)
// It allows for focus and the correct sidebar settings to render when the block is selected.

import React, { useContext } from "react"
import { useActiveBlock } from "app/regions/hooks/use-active-block"
import { BlockContext } from "app/regions/context/block-context"
import { setHoverBlock, useHoverBlock } from "@convertkit/editor"

export function Block({ id, children, dimensions, ...props }) {
  const { blocks } = useContext(BlockContext) || {}
  const { setActiveBlockId, activeBlock } = useActiveBlock()
  const hoverBlock = useHoverBlock()

  const handleSelection = () => {
    if (id !== activeBlock?.block_id) setActiveBlockId(id)
  }

  const handleKeySelection = event => {
    if (event.key === " ") {
      handleSelection()
    }
  }

  const handleMouseEnter = () => {
    if (id !== hoverBlock?.block_id)
      setHoverBlock(blocks.find(block => block.block_id === id))
  }

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onKeyPress={handleKeySelection}
      data-block-id={id}
      onClick={handleSelection}
      role="presentation"
      {...props}
    >
      {children}
    </div>
  )
}
